module.exports = __WEBPACK_EXTERNAL_MODULE_277__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/display3D/textures/VideoTexture","root":["openfl","display3D","textures","VideoTexture"],"commonjs":"openfl/display3D/textures/VideoTexture","commonjs2":"openfl/display3D/textures/VideoTexture"}
// module id = 277
// module chunks = 0